import React from "react";
import "./Field.scss";
import Tooltip from "../Tooltip/Tooltip";

/**
 * Field
 * @param {Object} props
 * @param {String} props.name Field name
 * @param {String} props.label Text label
 * @param {String} [props.help] Help text
 * @param {React.ReactElement} props.children
 * @param {Array.<{ value, label }>} props.options Options
 * @returns {React.ReactElement}
 */
function Field({ name, label, help, children }) {
  return (
    <div className="Field">
      <label htmlFor={name} className="Field__label">
        {label}
      </label>
      {help ? <Tooltip text={help} /> : null}
      <div className="Field__wrapper">{children}</div>
    </div>
  );
}

export default Field;
